import React from "react";
import Image from "next/image";

function AuthWrapper({ children, imageUrl }) {
  return (
    <div className="grid lg:grid-cols-2  w-full h-[32rem] my-[4.25rem] ">
      <div className="flex flex-col lg:items-center lg:justify-center">
        <div className="w-full px-[20px] sm:w-auto">{children}</div>
      </div>
      <div className="hidden lg:flex items-center justify-end">
        <Image
          src={imageUrl}
          width={708}
          height={512}
          alt="amarpet-login-page-image"
        />
      </div>
    </div>
  );
}

export default AuthWrapper;
